"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNewCropForResizedUserPhotoLayer = void 0;
const calculateNewCropForWidthChange_1 = require("./calculateNewCropForWidthChange");
const calculateNewCropForHeightChange_1 = require("./calculateNewCropForHeightChange");
const utils_1 = require("./utils");
const getNewCropForResizedUserPhotoLayer = (surface, oldLayer, newLayerSizeInPercent) => {
  var _a, _b, _c, _d, _e, _f;
  const oldCrop = ((_a = oldLayer === null || oldLayer === void 0 ? void 0 : oldLayer.userData) === null || _a === void 0 ? void 0 : _a.modifications).crop;
  const rotation = ((_b = oldLayer === null || oldLayer === void 0 ? void 0 : oldLayer.userData) === null || _b === void 0 ? void 0 : _b.modifications).rotation;
  const imageWidth = (0, utils_1.shouldFlipDimensions)(rotation) ? (_c = oldLayer.userData) === null || _c === void 0 ? void 0 : _c.imageData.height : (_d = oldLayer.userData) === null || _d === void 0 ? void 0 : _d.imageData.width;
  const imageHeight = (0, utils_1.shouldFlipDimensions)(rotation) ? (_e = oldLayer.userData) === null || _e === void 0 ? void 0 : _e.imageData.width : (_f = oldLayer.userData) === null || _f === void 0 ? void 0 : _f.imageData.height;
  if (!oldCrop || !imageWidth || !imageHeight) {
    throw new Error('Missing old crop or image width/height.');
  }
  // We maintain the aspect ratio when resizing from a corner so we can keep the old crop
  if (isResizingCorner(oldLayer, newLayerSizeInPercent)) {
    return oldCrop;
  }
  const newCrop = calculateNewCrop({
    surface,
    oldLayer,
    oldCrop,
    newLayerSizeInPercent,
    imageWidth,
    imageHeight
  });
  const limitedCrop = limitCropToImage(newCrop, imageWidth, imageHeight);
  return limitedCrop;
};
exports.getNewCropForResizedUserPhotoLayer = getNewCropForResizedUserPhotoLayer;
const isResizingCorner = (oldLayer, newImageWellSize) => {
  return isHeightChanged(oldLayer, newImageWellSize) && isWidthChanged(oldLayer, newImageWellSize);
};
const isHeightChanged = (oldLayer, newImageWellSize) => {
  return Math.abs(oldLayer.height - newImageWellSize.height) > 0.00001;
};
const isWidthChanged = (oldLayer, newImageWellSize) => {
  return Math.abs(oldLayer.width - newImageWellSize.width) > 0.00001;
};
const calculateNewCrop = _ref => {
  let {
    surface,
    oldLayer,
    oldCrop,
    newLayerSizeInPercent,
    imageWidth,
    imageHeight
  } = _ref;
  if (!imageWidth || !imageHeight) {
    throw new Error('Missing image width/height.');
  }
  if (isWidthChanged(oldLayer, newLayerSizeInPercent)) {
    return (0, calculateNewCropForWidthChange_1.calculateNewCropForWidthChange)({
      oldLayer,
      oldCrop,
      newLayerSizeInPercent,
      imageWidth,
      surface
    });
  }
  if (isHeightChanged(oldLayer, newLayerSizeInPercent)) {
    return (0, calculateNewCropForHeightChange_1.calculateNewCropForHeightChange)({
      oldLayer,
      oldCrop,
      newLayerSizeInPercent,
      surface,
      imageHeight
    });
  }
  return oldCrop;
};
const limitCropToImage = (crop, imageWidth, imageHeight) => {
  const newCrop = {
    x: crop.x,
    y: crop.y,
    width: crop.width,
    height: crop.height
  };
  if (crop.x < 0) {
    newCrop.x = 0;
  }
  if (crop.y < 0) {
    newCrop.y = 0;
  }
  if (crop.width > imageWidth) {
    newCrop.width = imageWidth;
  }
  if (crop.height > imageHeight) {
    newCrop.height = imageHeight;
  }
  const cropWidthOverflow = newCrop.x + newCrop.width - imageWidth;
  if (cropWidthOverflow > 0) {
    newCrop.x -= Math.min(newCrop.x, cropWidthOverflow);
  }
  const cropHeightOverflow = newCrop.y + newCrop.height - imageHeight;
  if (cropHeightOverflow > 0) {
    newCrop.y -= Math.min(newCrop.y, cropWidthOverflow);
  }
  return newCrop;
};